<div class="row justify-content-center">

  <div class="col-lg-8 content-area">

    <div class="page-card">
      <div id="reports">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'reports'">
          Reports
        </h2>

        <p class="f-s-14">
          You have the option to view the available reports. To open a specific report, click on <strong>‘View Report’</strong>.
        </p>

        <ul class="f-s-14">
          <li>
            <strong>Charity List Report</strong> - This report provides a list of all the imported charities in the software. Select the option you want and click on ‘Run Report’.
          </li>
        </ul>

        <img src="../../../../assets/images/logos/charitylistreport.jpg" />

        <ul class="f-s-14">
          <li>
            <strong>Trustee List Report</strong> - This report provides a list of all current and past trustees for a selected charity. Select the option you want and click on ‘Run Report’.
          </li>
        </ul>

        <img src="../../../../assets/images/logos/trusteerep.png" />

        <ul class="f-s-14">
          <li>
            <strong>Trial Balance Report</strong> - This report provide the details of Trial Balance for a selected Charity and Accounting Period. Select the option you want and click on ‘Run Report’.
          </li>
        </ul>

        <img src="../../../../assets/images/logos/trailbalancereport.png" />

        <ul class="f-s-14">
          <li>
            <strong>Chart of Accounts Report</strong> - This report provide the details of Chart of Accounts.
          </li>
        </ul>

        <p class="f-s-14">
          In every report, you will have two options ‘Print’ &amp; ‘Export As’.
        </p>
      </div>

      <div id="printreport">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'printreport'">
          Print
        </h2>

        <p class="f-s-14">
          You print the report using this option &amp; also have following options before printing
        </p>

        <ul class="f-s-14">
          <li>
            <strong>Toggle Sidebar</strong> - You can select and view any page of the report.
          </li>
        </ul>

        <img src="../../../../assets/images/logos/viewpagereport.png" />

        <ul class="f-s-14">
          <li>
            <strong>Find in Document</strong> - You search any particular part from the report.
          </li>
        </ul>


        <img src="../../../../assets/images/logos/Finddocument2.jpg" />

        <ul class="f-s-14">

          <li>
            <strong>Previous &amp; Next Page</strong>- You can jump to the previous and next page.  <img src="../../../../assets/images/logos/prevnextpage.png" />
          </li>

          <li><strong>Automatic Zoom</strong>- You can zoom in or zoom out with this option <img src="../../../../assets/images/logos/automaticzoom.jpg" /></li>

          <li>
            <strong>Switch to Presentation Mode</strong>- You can switch the report to the presentation mode <img src="../../../../assets/images/logos/view.jpg" />
          </li>

          <li>
            <strong>Open File</strong>- You can open file on the system <img src="../../../../assets/images/logos/open.png" />
          </li>

          <li>
            <strong>Print &amp; Download</strong>- You can print &amp; download the report <img src="../../../../assets/images/logos/printdownload.png" />
          </li>

          <li><strong>Current View</strong>- You can copy or open the current view in new tab <img src="../../../../assets/images/logos/save.jpg" /></li>

          <li>
            <strong>Tools</strong>- You have mentioned options in the tools
          </li>
        </ul>

        <img style="height: 300px;" src="../../../../assets/images/logos/optiontools.png" />
      </div>
      
      <div id="exportas">
        <h2 class="f-s-20 f-w-700 m-t-24"
            [class.active-heading]="selectedSection === 'exportas'">
          Export As
        </h2>

        <p class="f-s-14">
          You can export the reports in both PDF &amp; Excel format.
        </p>
      </div>
      </div>
    </div>

  <div class="col-lg-3">

    <div class="on-page-sidebar">

      <p class="sidebar-title">On this page</p>

      <ul class="scroll-container borderleft submenu-level-2">

        <li [class.active]="selectedSection === 'reports'"
            (click)="changeSection('reports')">
          <a>Reports</a>
        </li>

        <li [class.active]="selectedSection === 'printreport'"
            (click)="changeSection('printreport')">
          <a>Print</a>
        </li>

        <li [class.active]="selectedSection === 'exportas'"
            (click)="changeSection('exportas')">
          <a>Export As</a>
        </li>

      </ul>

    </div>
  
  </div>

  </div>
